module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt6 tc"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('pl-button', {
    staticClass: "pl-primary",
    nativeOn: {
      "click": function($event) {
        return _vm.$router.push('login')
      }
    }
  }, [_vm._v("\n    Back\n  ")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('img', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "src": "/static/logos/parlay_logo.svg",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pl-title mv4"
  }, [_vm._v("\n    Oops! It looks like we couldn't locate your account.\n\n    "), _c('br'), _c('br'), _vm._v("\n    Clever login is only available if your school or district\n    "), _c('br'), _vm._v("\n    is a Parlay member and created an account on your behalf.\n    "), _c('br'), _c('br'), _vm._v("\n    Click below to login or signup with your email.\n  ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-267ec317!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/errorPages/clever_error.vue
// module id = 1927
// module chunks = 61